var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviewsDoodles({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 480,
    height: 480,
    viewBox: "0 0 480 480",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#b9a2f1",
    strokeOpacity: 0.42,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52 56l5 13 13 5-13 5-5 13-5-13-13-5 13-5 5-13Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 72,
    r: 19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164 42v8m0 44v8m30-30h-8m-44 0h-8m51-21-6 6m-30 30-6 6m42 0-6-6m-30-30-6-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287 48v52m18-38v38m18-66v66m18-44v44m-58-34h18m4-8h18m4-10h18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410 67c8-13 22-13 29 0 7 12-1 26-15 33-14-7-22-21-14-33Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424 101v15m-11 0h22"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 188,
    r: 23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73,
    cy: 184,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 184,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 196c5 5 11 5 16 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191 167c13 4 20 17 16 30-4 14-18 21-31 16-14-4-21-18-17-31 4-13 18-20 32-15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176 194 10 9 18-22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303 168c-15 0-27 12-27 27v18h54v-18c0-15-12-27-27-27Zm-11 45v9m22-9v9m-17-51c2-9 12-13 20-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m405 168 5 12 13 5-13 5-5 13-5-13-13-5 13-5 5-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 292h50m-43 0v38m17-56v56m17-26v26m-34-22h17m17 4h16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164 278c-15 17-17 36-4 49 13 13 32 10 48-5-4-19-20-35-44-44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162 323c12-12 22-22 38-34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285 279v53m18-32v32m18-47v47m18-25v25m-54-29h18m0-7h18m0-8h18"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 304,
    r: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420 279v50m-25-25h50m-42-17 34 34m0-34-34 34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 407c0-13 10-23 23-23s23 10 23 23v20H60v-20Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 384v-9m20 9v-9m-10 33v19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184 384 5 13 13 5-13 5-5 13-5-13-13-5 13-5 5-13Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303,
    cy: 405,
    r: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292 404h22m-11-11v23m-15-4 26-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 389h43m-43 14h31m-31 14h37m-55-39v47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m119 126 7 8-7 8-7-8 7-8Zm244 83 7 8-7 8-7-8 7-8Zm-246 144 7 8-7 8-7-8 7-8Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#8b73c8",
    strokeOpacity: 0.32,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 116h30m-15-15v30m390 37h30m-15-15v30M118 250h30m-15-15v30m211 144h30m-15-15v30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228 106c7 7 7 18 0 25-7-7-7-18 0-25Zm-99 198c9 0 15 8 13 17-9 2-17-4-17-13m205-13c9 0 15 8 13 17-9 2-17-4-17-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365 270c-11 7-15 18-10 29 11-2 19-13 17-25m-5 19 10-13"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewsDoodles);
export default __webpack_public_path__ + "static/media/reviews-doodles.a0c95e1899c1d4493bd68e97fa8f3a9e.svg";
export { ForwardRef as ReactComponent };